
import {
  deleteShinseishaIppan,
  deleteShinseishaKanri,
  getShinseishaList,
} from "@/api/account.api";
import { ComfirmMsg, InfoMsg } from "@/constants/message.constant";
import { QueryShinseisha } from "@/interfaces/account.interface";
import { dateFormat } from "@/utils/date";
import { defineComponent, h, reactive, ref } from "vue";
import { ElMessageBox, ElMessage } from "element-plus";
import { DialogGenre } from "@/interfaces/common.interface";
import { ShinseishaInfo, tableConfig, Prop2LabelMap } from "./config";
import { Kengen } from "@/constants/role.constant";
import Dialog from "./Dialog.vue";
import { ELEMENT_ACCESS } from "@/constants/accessList.constant";
import dayjs from "dayjs";
import { ErrorMsg } from "@/constants/message.constant";
import { useUserStore } from "@/store";
import useTable from "@/hooks/useTable";
import useDialog from "@/hooks/useDialog";
import { DatePattern } from "@/constants/common.constant";

export default defineComponent({
  components: {
    Dialog,
  },
  setup() {
    const table = reactive({
      queryForm: {
        kaishaNm: "",
        groupNm: "",
        name: "",
        page: 1,
        limit: 20,
      } as QueryShinseisha,
      list: [] as ShinseishaInfo[],
      total: 0,
      loading: true,
    });

    // 検索
    //検索メイン処理
    const userStore = useUserStore();
    const setData = (listData: any, list: ShinseishaInfo[]) => {
      for (let i = 0; i < listData.length; i++) {
        list.push({
          id: listData[i].id,
          accountId: listData[i].account.akaunto_id,
          email: listData[i].account.mail_address,
          kaishaCd: listData[i].kaishaGroup?.kaisha.kaisha_cd,
          kaishaNm: listData[i].kaishaGroup?.kaisha.kaisha_nm,
          groupNm: listData[i].kaishaGroup?.kaisha_group_nm,
          kjnNm: listData[i].kjn_nm,
          bushoNm: listData[i].busho_nm,
          kengenCd: listData[i].account.kengen.kengen_kubun_cd,
          kengen: listData[i].account.kengen.kengen_kubun,
          createdDate: dateFormat(listData[i].account.toroku_date),
          updatedDate: dateFormat(listData[i].account.koshin_date),
        });
      }
    };
    const getList = async () => {
      table.loading = true;
      table.list = [];
      const { data } = await getShinseishaList(table.queryForm);
      const { listData, total } = data.result;
      table.total = total;
      setData(listData, table.list);
      table.loading = false;
    };

    const tableRef = ref();
    const { handleSizeChange, handleSearch, handleClear } = useTable(
      table,
      getList,
      tableRef
    );

    /**
     * 権限別のexcel 出力内容の除外項目
     */
    const getExcludeList: () => (keyof ShinseishaInfo)[] = () => {
      return userStore.isShoninsha
        ? ["id", "kengenCd"]
        : ["id", "kengenCd", "kaishaCd"]
    }

    /* 
    申請者の修正・削除ボタン制御。
    ・承認者は申請者（一般）、申請者（管理）を修正できる
    ・申請者（管理）は申請者（一般）を修正できる
  */
    const canEdit = (kengenCd: string) => {
      if (userStore.isShoninsha) {
        return true;
      }
      return kengenCd === Kengen.一般;
    };

    //削除イベント
    const handleDelete = (row: ShinseishaInfo) => {
      ElMessageBox({
        title: "確認",
        message: h("p", null, [
          h("p", { style: "color: #b87d11" }, "アカウントID：" + row.accountId),
          h("p", { style: "color: #b87d11" }, "個人名：" + row.kjnNm),
          h("span", null, ComfirmMsg.CFM_DELETE),
        ]),
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "はい",
        cancelButtonText: "いいえ",
      })
        .then(async () => {
          //削除処理
          row.kengenCd === Kengen.管理
            ? await deleteShinseishaKanri(row.accountId)
            : await deleteShinseishaIppan(row.accountId);
          ElMessage({
            type: "success",
            message: InfoMsg.INFO_SHINSEISHA_DELETED,
          });
          handleSearch(table.queryForm.page);
        })
        .catch((cancel) => {
          console.log(cancel);
        });
    };

    //excel出力イベント
    const exportLoading = ref(false);
    const handleExport2excel = async () => {
      try {
        exportLoading.value = true;
        //出力データセット
        const { data } = await getShinseishaList({
          kaishaNm: table.queryForm.kaishaNm,
          groupNm: table.queryForm.groupNm,
          name: table.queryForm.name,
          page: 0,
          limit: 0,
        });
        const { listData } = data.result;
        const list: ShinseishaInfo[] = [];
        setData(listData, list);
        //出力処理
        const { aoaToSheetXlsx } = await import("@/utils/export2Excel"); //lazy load
        aoaToSheetXlsx({
          data: list,
          headerMapper: Prop2LabelMap,
          filename: `${dayjs().format(
            DatePattern.SimpleDatePattern
          )}_申請者リスト.xlsx`,
          exclude: getExcludeList(), //出力しない列
        });
      } catch (error) {
        ElMessage.error(ErrorMsg.ERR_EXPORT_FAIL);
      } finally {
        exportLoading.value = false;
      }
    };

    //ダイアログ利用
    const { dialogTitle, dialogOperation, openDialog } = useDialog("申請者");

    getList();

    return {
      table,
      tableConfig,
      getList,
      handleClear,
      handleSearch,
      handleDelete,
      DialogGenre,
      dialogTitle,
      dialogOperation,
      openDialog,
      handleSizeChange,
      Kengen,
      ELEMENT_ACCESS,
      handleExport2excel,
      exportLoading,
      tableRef,
      canEdit,
    };
  },
});
